import React from 'react';
import { CityOrderControl } from './CityOrderControl';
import { DesktopBlockOrderControl } from './DesktopBlockOrderControl';
import { MapStyle, MonsterTokenStyle, UserSettings } from '../api';
import { setStoredEncounterIcons, useEncounterIcons, setStoredHideRailroads, useHideRailroads, setStoredMonsterTokenScale, useMonsterTokenScale } from '../utils/clientSettings';
interface DisplaySettingsViewProps {
  monsterTokenStyle: MonsterTokenStyle;
  mapStyle?: MapStyle;
  otherWorldsBelowMap?: boolean;
  onSettingsChange: (settings: Partial<UserSettings>) => void;
}
export const DisplaySettingsView: React.FC<DisplaySettingsViewProps> = ({
  otherWorldsBelowMap = false, monsterTokenStyle: selectedMonsterTokenStyle, mapStyle = 'Reworked',
  onSettingsChange,
}) => {
  const monsterTokenScale = useMonsterTokenScale();
  const encounterIcons = useEncounterIcons();
  const hideRailroads = useHideRailroads();
  const monsterTokenScaleLabel = `×${Number(monsterTokenScale.toFixed(2))}`;
  const handleMonsterTokenStyleChange = (style: MonsterTokenStyle) => {
    if (
      style === 'Classic' &&
      selectedMonsterTokenStyle !== 'Classic' &&
      !window.confirm('Classic images use artwork from the original board game. By selecting Classic, you confirm that you own a physical copy of Arkham Horror Second Edition. Continue?')
    ) {
      return;
    }
    onSettingsChange({ monsterTokenStyle: style });
  };
  const handleMapStyleChange = (style: MapStyle) => {
    if (style === 'Classic' && mapStyle !== 'Classic' &&
      !window.confirm('Classic maps use artwork from the original board game. By selecting Classic, you confirm that you own a physical copy of Arkham Horror Second Edition. Continue?')) return;
    onSettingsChange({ mapStyle: style });
  };

  return <form className="settings-form" onSubmit={event => event.preventDefault()}>
    <div className="settings-field">
      <label htmlFor="monster-token-style-select">Artwork</label>
      <select
        id="monster-token-style-select"
        className="select-input"
        value={selectedMonsterTokenStyle}
        onChange={(event) => handleMonsterTokenStyleChange(event.target.value as MonsterTokenStyle)}
      >
        <option value="Digital">Digital</option>
        <option value="Classic">Classic</option>
      </select>
    </div>

    <div className="settings-field">
      <label htmlFor="map-style-select">Map</label>
      <select id="map-style-select" className="select-input" value={mapStyle}
        onChange={(event) => handleMapStyleChange(event.target.value as MapStyle)}>
        <option value="Reworked">Digital</option>
        <option value="Classic">Classic</option>
      </select>
    </div>

    <div className="settings-field">
      <label htmlFor="monster-token-scale">Monster Tokens size</label>
      <span aria-hidden="true">{monsterTokenScaleLabel}</span>
      <input id="monster-token-scale" type="range" min="-1" max="1" step="0.01"
        value={Math.log2(monsterTokenScale)} aria-valuetext={monsterTokenScaleLabel}
        disabled={selectedMonsterTokenStyle !== 'Digital' || mapStyle !== 'Reworked'}
        onChange={event => setStoredMonsterTokenScale(2 ** Number(event.target.value))} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }} aria-hidden="true">
        <span>×0.5</span><span>×1</span><span>×2</span>
      </div>
    </div>

    <div className="settings-field">
      <label className="checkbox-label">
        <input type="checkbox" checked={encounterIcons} disabled={mapStyle === 'Classic'}
          onChange={event => setStoredEncounterIcons(event.target.checked)} />
        Encounter icons
      </label>
    </div>

    <div className="settings-field">
      <label className="checkbox-label">
        <input type="checkbox" checked={otherWorldsBelowMap} disabled={mapStyle === 'Classic'}
          onChange={event => onSettingsChange({ otherWorldsBelowMap: event.target.checked })} />
        Other Worlds below map
      </label>
    </div>
    <div className="settings-field">
      <label className="checkbox-label">
        <input type="checkbox" checked={hideRailroads} disabled={mapStyle === 'Classic'}
          onChange={event => setStoredHideRailroads(event.target.checked)} />
        Hide Railroads
      </label>
    </div>
    <CityOrderControl showOtherWorlds={otherWorldsBelowMap && mapStyle !== 'Classic'} />
    <DesktopBlockOrderControl />
  </form>;
};
